// client/src/services/contentReads.ts
//
// FEAT CONTENT-READS (16 Set 2026): "chi ha letto" notizie e broadcast.
// Quando l'utente apre una notizia admin o un broadcast (tap sulla push),
// segnala al server la lettura → delivery_recipients.read_at viene
// valorizzato e l'admin vede chi ha letto nel pannello.
//
// Fire-and-forget: la lettura è best-effort, non deve mai disturbare l'UX.

import { apiFetch } from "@/api/core/apiFetch";

export type ReadableContentKind = "news" | "broadcast";

export async function markContentRead(
  kind: ReadableContentKind,
  id: string,
): Promise<boolean> {
  if (!id) return false;
  try {
    const res: any = await apiFetch(`/api/system/${kind}/${id}/read`, {
      method: "POST",
    });
    return res?.ok === true;
  } catch {
    return false;
  }
}

/** Notifica ricevuta da push: estrae tipo + id contenuto se leggibile. */
export function extractReadableContent(
  data: Record<string, unknown> | null | undefined,
): { kind: ReadableContentKind; id: string } | null {
  if (!data) return null;
  if (data.type === "admin_news" && typeof data.news_id === "string") {
    return { kind: "news", id: data.news_id };
  }
  if (data.type === "admin_broadcast" && typeof data.broadcast_id === "string") {
    return { kind: "broadcast", id: data.broadcast_id };
  }
  return null;
}
